import { render, staticRenderFns } from "./ticketmaster-venues.datatable.vue?vue&type=template&id=f601d17c&scoped=true&"
import script from "./ticketmaster-venues.datatable.vue?vue&type=script&lang=js&"
export * from "./ticketmaster-venues.datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f601d17c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
